import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { GetForm } from './modalForm';
import { useStore } from 'src/stores';
export const CreateEditPortfolioModal = observer(_ref => {
  let isEditMode = _ref.isEditMode,
    existingPortfolio = _ref.existingPortfolio,
    customTrigger = _ref.customTrigger,
    triggerRefresh = _ref.triggerRefresh,
    isCreateAndMoveProperties = _ref.isCreateAndMoveProperties,
    showModal = _ref.showModal,
    handleShowModal = _ref.handleShowModal;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  const internalTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '306-CreateEditPortfolio'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "New portfolio"));
  const handleModalOpen = () => {
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    triggerRefresh && triggerRefresh();
  };
  useEffect(() => {
    if (showModal && handleShowModal) {
      setIsModalOpen(true);
      handleShowModal(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);
  if (!store.account.userProfile.isUserPmHolderOrHigher) {
    return null;
  }
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: isEditMode ? t('portfolios_properties_page.edit_portfolio') : t('portfolios_properties_page.new_portfolio'),
    subTitle: !!isCreateAndMoveProperties && t('portfolios_properties_page.you_are_about_to_move_num_properties', {
      propertiesNumber: store.portfoliosMultiActionStore.selectedItems.length
    }),
    variant: isEditMode ? undefined : 'staticHeight',
    isOpen: isModalOpen,
    handleOpen: handleModalOpen,
    handleClose: handleModalClose,
    trigger: customTrigger !== undefined ? customTrigger : internalTrigger,
    noFooter: true,
    noPadding: true,
    noLeftButton: true
  }, /*#__PURE__*/React.createElement(GetForm, {
    existingPortfolio: existingPortfolio,
    isEditMode: isEditMode,
    triggerRefresh: triggerRefresh,
    isCreateAndMoveProperties: isCreateAndMoveProperties
  }));
});